import { useState, useEffect } from "react";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import contractABI from "../../assets/contractABI.json";
import { useWallet } from "WalletProvider";
import { readContracts } from "@wagmi/core";
import { config } from "index";
import { getChainName } from "utilities/utilites";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { Card, Grid } from "@mui/material";
import Table from "examples/Tables/Table";
import { IoCash, IoGlobe, IoStorefront, IoWallet } from "react-icons/io5";
import { ethers } from "ethers";
import Footer from "examples/Footer";

export default function AdminDashboard() {
  const { wallet, selectedChain } = useWallet();
  const [metrics, setMetrics] = useState([]);
  const coreContract = {
    address: process.env.REACT_APP_PROXY_CONTRACT_ADDRESS,
    abi: contractABI,
  };

  useEffect(() => {
    
    async function fetchMetrics() {
      const result = await readContracts(config, {
        contracts: [
          {
            ...coreContract,
            functionName: "getTotalMarketsCount",
          },
          {
            ...coreContract,
            functionName: "getTotalMarketsByChain",
            args: [selectedChain],
          },
          {
            ...coreContract,
            functionName: "getPlatformRevenuePerChain",
            args: [selectedChain],
          },
          {
            ...coreContract,
            functionName: "getCreatorsAndRevenuesByChain",
            args: [selectedChain],
          },
          {
            ...coreContract,
            functionName: "getTotalDepositsByChain",
            args: [selectedChain],
          },
          {
            ...coreContract,
            functionName: "getUniqueDepositorsCountByChain",
            args: [selectedChain],
          },
          {
            ...coreContract,
            functionName: "getLatestPrice",
          },
        ],
      });
      
      setMetrics(result);
    }
    fetchMetrics();
  }, [selectedChain]);

  const rows =
    metrics[3]?.result?.map((item) => ({
      creator: (
        <VuiBox display="flex" alignItems="center">
          <VuiTypography pl="16px" color="white" variant="button" fontWeight="medium">
            {item.creator}
          </VuiTypography>
        </VuiBox>
      ),
      revenue: (
        <VuiTypography variant="button" color="white" fontWeight="bold">
          {item.revenue
            ? `USD ${(
                Number(ethers.utils.formatEther(item.revenue)) *
                (Number(metrics[6].result) / 1e8)
              ).toFixed(2)}`
            : "USD 0.00"}
            {" "}
          {item.revenue
            ? `(${Number(ethers.utils.formatEther(item.revenue)).toFixed(2)} ETH)`
            : "(0.00 ETH)"}
        </VuiTypography>
      ),
    })) || [];
  

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <VuiBox mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} xl={3}>
            <MiniStatisticsCard
              title={{ text: "Total Markets(All Chains)", fontWeight: "regular" }}
              count={Number(metrics[0]?.result || 0).toString()}
              icon={{ color: "info", component: <IoGlobe size="22px" color="white" /> }}
            />
          </Grid>
          <Grid item xs={12} md={6} xl={3}>
            <MiniStatisticsCard
              title={{ text: `Total Markets (${getChainName(selectedChain)})` }}
              count={Number(metrics[1]?.result || 0).toString()}
              icon={{ color: "info", component: <IoStorefront size="22px" color="white" /> }}
            />
          </Grid>
          <Grid item xs={12} md={6} xl={3}>
            <MiniStatisticsCard
              title={{ text: `Total Platform Revenue(${getChainName(selectedChain)})` }}
              count={
                metrics[2]?.result && metrics[6]?.result
                  ? `USD ${(
                      Number(ethers.utils.formatEther(metrics[2].result)) *
                      (Number(metrics[6].result) / 1e8)
                    ).toFixed(2)}`
                  : "USD 0.00"
              }
              value={
                metrics[2]?.result && metrics[6]?.result
                  ? `(${Number(ethers.utils.formatEther(metrics[2].result)).toFixed(2)} ETH)`
                  : "(0.00 ETH)"
              }
              icon={{ color: "info", component: <IoCash size="22px" color="white" /> }}
            />
          </Grid>
          <Grid item xs={12} md={6} xl={3}>
            <MiniStatisticsCard
              title={{ text: "Total Wallets Connected" }}
              count={Number(metrics[5]?.result || 0).toString()}
              icon={{ color: "info", component: <IoWallet size="20px" color="white" /> }}
            />
          </Grid>
        </Grid>
      </VuiBox>
      <Card
        sx={{
        //   height: "100% !important",
          height: "100vh", 
        }}
      >
        <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="32px">
          <VuiBox mb="auto">
            <VuiTypography color="white" variant="lg" mb="6px" gutterBottom>
              Revenue By Creator ({getChainName(selectedChain)})
            </VuiTypography>
          </VuiBox>
        </VuiBox>
        <VuiBox
          sx={{
            "& th": {
              borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                `${borderWidth[1]} solid ${grey[700]}`,
            },
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                  `${borderWidth[1]} solid ${grey[700]}`,
              },
            },
          }}
        >
          <Table
            columns={[
              { name: "creator", align: "left" },
              { name: "revenue", align: "left" },
            ]}
            rows={rows}
          />
        </VuiBox>
      </Card>
      <Footer/>
    </DashboardLayout>
  );
}
